import React from "react";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./style.module.css";

const Contact = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@simsim.az";
  };

  return (
    <Container
      fluid
      className={styles.contactContainer} // Applied the suggested code change
    >
      <h1 className="text-center mb-5">Bizimlə Əlaqə Saxlayın</h1>
      <Row className="g-4 justify-content-evenly">
        <Col
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className="d-flex justify-content-center align-items-stretch"
        >
          <Card
            className={`text-center p-4 shadow card-main ${styles.cardContainer} ${styles.cardWithHeight} ${styles.cardWithTransition}`}
          >
            <Card.Body>
              <div className="mb-3 d-flex justify-content-center">
                <i className={`bi bi-whatsapp ${styles.iconLarge}`}></i>
              </div>
              <Card.Title className={styles.cardTitle}>
                +994 50 247 37 36
              </Card.Title>
              <Button
                variant="dark"
                className={`mt-3 w-100 ${styles.contactButton}`}
                href="https://wa.me/+994502473736"
              >
                Mesaj Yaz
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className="d-flex justify-content-center align-items-stretch"
        >
          <Card
            className={`text-center p-4 shadow card-main ${styles.cardContainer}`}
          >
            <Card.Body>
              <div className="mb-3 d-flex justify-content-center">
                <i className={`bi bi-telephone ${styles.iconLarge}`}></i>
              </div>
              <Card.Title className={styles.cardTitle}>
                +994 50 247 37 36
              </Card.Title>
              <Button
                variant="dark"
                className={`mt-3 w-100 ${styles.contactButton}`}
                href="tel:+994502473736"
              >
                Zəng Et
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className="d-flex justify-content-center align-items-stretch"
        >
          <Card
            className={`text-center p-4 shadow card-main ${styles.cardContainer}`}
          >
            <Card.Body>
              <div className="mb-3 d-flex justify-content-center">
                <i className={`bi bi-envelope ${styles.iconLarge}`}></i>
              </div>
              <Card.Title className={styles.cardTitle}>
                info@simsim.az
              </Card.Title>
              <Button
                variant="dark"
                className={`mt-3 w-100 ${styles.contactButton}`}
                onClick={handleEmailClick}
              >
                Email Yaz
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
